module.exports = __webpack_public_path__ + "img/chrome9.67d73381.png";